<template>
    <div class="panel" v-if="record.additional_info">
        <div class="panel-body">
            <h5 class="m-t-0">
                <i class="fa-fw m-r-5 fa fa-info-circle"></i> {{ $t('additional_info') }} 
            </h5>
            <div v-html="record.additional_info"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Info',
        props: [ 'record' ]
    }
</script>


// WEBPACK FOOTER //
// src/modules/my-quotation/components/Info.vue